import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Checkbox,
	Container,
	Divider,
	FormControlLabel,
	Grid,
	TextField,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { createFormData } from "nhb-toolbox";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import FullScreenSpinner from "src/components/Spinner/FullScreenSpinner";
import Spinner from "src/components/Spinner/Spinner";
import { useApiMutation } from "src/hooks/useApiMutation";
import { useApiQuery } from "src/hooks/useApiQuery";
import { muiStyles } from "../../../Utils/Styles";

interface IAdminRoles {
	roles_id: number;
	roles_name: string;
}

const useStyles = muiStyles;
const CreateAdmin = () => {
	const classes = useStyles();
	const { register, handleSubmit, reset } = useForm();
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [zone, setZone] = React.useState<string>("");
	const [role, setRole] = React.useState<string>("");

	const handleChange = (event: SelectChangeEvent) => {
		setZone(event.target.value as string);
	};

	const { data: roles = [], isLoading } = useApiQuery<IAdminRoles[]>({
		endPoint: `/api/admin/get/roles`,
		queryKeys: ["AdminRoles"],
		params: {},
	});

	const { mutate: createAdmin, isPending } = useApiMutation<FormData, void>({
		method: "POST",
		endPoint: `/api/admin/create/an/admin`,
		invalidateQueries: ["Admins"],
	});

	const onSubmit = (inputs: Record<string, unknown>) => {
		const formattedData = createFormData({
			...inputs,
			user_admin_role: Number(role),
		});

		createAdmin(formattedData);
		reset();
	};

	if (isLoading) {
		return <FullScreenSpinner />;
	}

	return (
		<div>
			<Helmet>
				<title>BTTF - Create Admin</title>
			</Helmet>

			<Container sx={{ mt: 4 }} maxWidth='lg'>
				<Card>
					<CardHeader title='Create Admin' />
					<Divider />
					<CardContent>
						<Box sx={{ p: 2 }} className=''>
							<Box
								component='form'
								onSubmit={handleSubmit(onSubmit)}
								sx={{
									mt: 1,
								}}
							>
								<Grid container spacing={2}>
									<Grid item xs={12} md={6} lg={3}>
										<TextField
											margin='normal'
											required
											fullWidth
											id='name'
											label='User Admin Name'
											{...register("user_admin_name")}
											type='text'
											autoFocus
											variant='filled'
											className={classes.inputText}
											InputProps={{ classes }}
										/>
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<TextField
											margin='normal'
											required
											fullWidth
											id='phone'
											label='Phone'
											{...register("user_admin_phone")}
											type='number'
											autoFocus
											variant='filled'
											className={classes.inputText}
											InputProps={{ classes }}
										/>
									</Grid>

									<Grid item xs={12} md={6} lg={3}>
										<TextField
											margin='normal'
											required
											fullWidth
											id='email'
											label='Email'
											{...register("user_admin_email")}
											type='email'
											autoFocus
											variant='filled'
											className={classes.inputText}
											InputProps={{ classes }}
										/>
									</Grid>

									{/* <Grid item xs={12} md={6} lg={3}>
										<TextField
											margin="normal"
											required
											fullWidth
											id="phone"
											label="Phone"
											{...register("user_admin_phone")}
											type="phone"
											autoFocus
											variant="filled"
											className={classes.inputText}
											InputProps={{ classes }}
										/>
									</Grid> */}
									<Grid
										// style={{
										// 	marginTop: -16,
										// }}
										item
										xs={12}
										md={6}
										lg={3}
									>
										<FormControl
											required
											margin='normal'
											fullWidth
										>
											<InputLabel
												required
												id='demo-simple-select-label'
											>
												Role
											</InputLabel>
											<Select
												labelId='demo-simple-select-label'
												id='demo-simple-select'
												value={role}
												label='role'
												required
												onChange={(e) => {
													setRole(e.target.value);
												}}
											>
												{roles?.map((role) => (
													<MenuItem
														key={role.roles_id}
														value={role.roles_id}
													>
														{role.roles_name}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>

									{/* <Grid item xs={12} md={6} lg={3}>
										<FormControl
											required
											margin="normal"
											fullWidth
										>
											<InputLabel
												required
												id="demo-simple-select-label"
											>
												Zone
											</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={zone}
												label="zone"
												required
												onChange={handleChange}
											>
												<MenuItem value={1}>
													Dhaka
												</MenuItem>
												<MenuItem value={2}>
													Chittagong
												</MenuItem>
												<MenuItem value={3}>
													Sylhet
												</MenuItem>
											</Select>
										</FormControl>
									</Grid> */}

									<Grid item xs={12} md={6} lg={3}>
										<TextField
											// margin="normal"
											required
											fullWidth
											id='file'
											label='Choose Admin Photo'
											InputLabelProps={{
												shrink: true,
											}}
											{...register("user_admin_photo")}
											autoComplete='file'
											type='file'
											autoFocus
										/>
									</Grid>

									<Grid item xs={12} md={6} lg={3}>
										<TextField
											// margin="normal"
											required
											fullWidth
											{...register("user_admin_password")}
											label='Password'
											type={`${
												showPassword
													? "text"
													: "password"
											}`}
											id='password'
											autoComplete='current-password'
											variant='filled'
											className={classes.inputText}
											InputProps={{ classes }}
										/>
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<TextField
											// margin="normal"
											required
											fullWidth
											{...register(
												"user_admin_confirm_password"
											)}
											label='Confirm Password'
											type={`${
												showPassword
													? "text"
													: "password"
											}`}
											id='password2'
											autoComplete='current-password'
											variant='filled'
											className={classes.inputText}
											InputProps={{ classes }}
										/>
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<FormControlLabel
											control={
												<Checkbox
													checked={showPassword}
													onClick={() =>
														setShowPassword(
															(prev) => !prev
														)
													}
													color='primary'
												/>
											}
											label='Show Password'
										/>
									</Grid>
								</Grid>

								<Button
									type='submit'
									fullWidth
									variant='contained'
									disableElevation
									sx={{
										mt: 3,
										mb: 2,
										py: 1,
									}}
								>
									{isPending ? <Spinner /> : "Create Admin"}
								</Button>
							</Box>
						</Box>
					</CardContent>
				</Card>
			</Container>
		</div>
	);
};

export default CreateAdmin;
